import { prefilledPollMock } from './prefilled-poll-mock';
export const prefilledPollWithEmptyValuesMock = {
    question: 'Type your question here',
    options: [
        prefilledPollMock.options[0],
        { text: '' },
        prefilledPollMock.options[1],
        { text: '' },
    ],
    openDays: 7,
};
//# sourceMappingURL=prefilled-poll-with-empty-values-mock.js.map